import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LogoutComponent } from 'pages/authentication/logout/logout.component';
import { ResetPasswordComponent } from 'pages/authentication/templates/reset-password/reset-password.component';
import {JOWITUserRoles} from 'helpers/interfaces';

function redirectToPathName() {
  const userInfo = JSON.parse(localStorage.getItem('userInfo'));

  if (userInfo) {
    const isJOWITAdmin = userInfo.roles.includes(JOWITUserRoles.ROLE_JOWIT_ADMIN_ORGANIZATION);
    return isJOWITAdmin ? '/manage/park/virtual-card' : '/index';
  } else {
    return 'login';
  }
}

const routes: Routes = [
  {path: 'login', loadChildren: './pages/authentication/auth.module#AuthModule'},
  {path: 'password/reset', component: ResetPasswordComponent},
  {path: 'logout', component: LogoutComponent},
	{path: '', redirectTo: 'login', pathMatch: 'full'},
];



@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts